export const secondsToTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  const hh = String(Math.ceil(hours)).padStart(2, '0');
  const mm = String(Math.ceil(minutes)).padStart(2, '0');
  const ss = String(Math.ceil(remainingSeconds)).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
};

export const timeToSeconds = (timeString) => {
  const [hh, mm, ss] = timeString.split(':').map(Number);
  const totalSeconds = hh * 3600 + mm * 60 + ss;
  return totalSeconds;
};
